import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const retweetsResolver: FieldResolver = (metadata: Metadata) =>
  ({ retweets: metadata.getRetweets() } as StreamData)

export default retweetsResolver
